// extracted by css-extract-rspack-plugin
export default {"resetButton":"dlIZXC3Rwn43VScM"};